module.exports = __webpack_public_path__ + "img/logo.f35de88e.svg";